import { MyIcon } from 'ccs-ui-components';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classes from './ServiceOperationHeader.module.scss';

interface IServiceOperationHeaderProps {
  showOpsForm: boolean;
}
const ServiceOperationHeader = ({
  showOpsForm
}: IServiceOperationHeaderProps) => {
  const { t: translate } = useTranslation();
  return (
    <div className={classes['form-header']}>
      {!showOpsForm && (
        <MyIcon name="caretRightFillIcon" className={classes['icon-right']} />
      )}
      {showOpsForm && (
        <MyIcon name="caretDownFillIcon" className={classes['icon-right']} />
      )}
      <Row className={classes.header}>
        <div className={classes['header-title']}>
          {translate('service_operation_form.service_operation_details_title')}
        </div>
        {showOpsForm && (
          <div className={classes.subtitle}>
            {translate(
              'service_operation_form.service_operation_details_sub_title'
            )}
          </div>
        )}
      </Row>
    </div>
  );
};

export default ServiceOperationHeader;
